import * as React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Typography } from 'components/DesignSystemV2/Typography';
import { withHomePageSection } from 'components/withHomePageSection';
import VideoInline from 'shared/VideoThumbnailInline/VideoInline';
import { colorsV2 } from 'style/colors-v2';
import { getAssetLinkByHandle } from 'utils/getAssetLink';
import { IconUpdate, IconGroup } from 'components/Icon/SVGIcons';
import { Rating } from 'components/Rating';
import { fromScreen } from 'utils/media-query/responsive.util';
import DolInfo from 'shared/DolInfo';
import { Link } from 'gatsby';
import Button from '@dolstaff/shared/es/Button';

const LevelVideo = styled(VideoInline)``;

const VideoContainer = styled.div`
  overflow: hidden;
  .thumbnail,
  video {
    border-radius: 8px;
  }

  .btn-action {
    width: 100%;
    margin-top: 16px;
    border-radius: 8px;
  }
`;

export const Header = React.memo(
  withHomePageSection(
    props => {
      const { level, rating, teachers } = props;

      return (
        <Container>
          <TextContainer
            id="course-landing-detail-header-text"
            className="header-course"
          >
            <div className="header-course-info">
              <div className="header-title">
                <Typography variant="bold/24" className="rating" as="h3">
                  {level.levelDisplay.replace('Khóa', '')}
                  <Rating stars={rating.starsInFloat} />
                </Typography>
                <Typography variant="regular/16">
                  {level.levelDescription}
                </Typography>
              </div>
              <div className="header-content">
                <div className="course-info">
                  {level.isBestSeller && <div className="tag">Bestseller</div>}
                </div>
                <div className="teacher-name">
                  Giáo viên:{' '}
                  {teachers
                    .map(teacher => teacher.displayName)
                    .filter(Boolean)
                    .join(', ')}
                </div>

                <div className="last-updated-at">
                  <Typography
                    style={{ color: colorsV2.black80 }}
                    variant="regular/14-20"
                  >
                    <IconGroup />
                    {level.numOfStudent} học viên đã học
                  </Typography>
                  <Typography
                    variant="regular/14-20"
                    style={{ color: colorsV2.green100 }}
                  >
                    <IconUpdate />
                    {level.updatedAt || 'Updated in December 2022'}
                  </Typography>
                </div>
              </div>
            </div>
            {level.levelVideo ? (
              <VideoContainer className="header-video">
                <LevelVideo
                  video={getAssetLinkByHandle({ handle: level.levelVideo })}
                  poster={level.levelVideoThumbnailHandle}
                  alt={level.levelDisplay}
                  onContextMenu={e => e.preventDefault()}
                  controlsList="nodownload"
                />

                <DolInfo>
                  {({ dolInfo }) => (
                    <Link
                      target="_blank"
                      href={dolInfo.messenger.href}
                      rel="noreferrer noopener"
                    >
                      <Button
                        size="large"
                        className="btn-action"
                        type="primary"
                        marginBottom="0"
                      >
                        <Typography
                          variant="semi-bold/14-24"
                          color={colorsV2.white100}
                        >
                          Nhắn DOL qua FB
                        </Typography>
                      </Button>
                    </Link>
                  )}
                </DolInfo>
              </VideoContainer>
            ) : null}
          </TextContainer>
        </Container>
      );
    },
    {
      selfish: true
    }
  )
);

const Container = styled.div`
  .header-video {
    .thumbnail {
      margin-bottom: 0;
    }
  }

  .header-course {
    display: grid;
    grid-template-rows: auto max-content;
    grid-row-gap: 16px;
  }

  .header-content {
    display: grid;
    grid-auto-flow: row;
    gap: 4px;
    .course-info {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      gap: 8px;
      grid-template-columns: max-content;
    }
    .tag {
      padding: 2px 4px;
      border-radius: 4px;
      background: ${colorsV2.primary100};
      border-radius: 4px;
      color: ${colorsV2.white100};
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
    }
    .teacher-name {
      color: ${colorsV2.black100};
      font-size: 16px;
      line-height: 28px;
    }
    .last-updated-at {
      margin-top: 4px;
      display: grid;
      gap: 4px;
      > p {
        display: grid;
        gap: 8px;
        grid-template-columns: max-content minmax(0, 1fr);
      }
      svg {
        font-size: 20px;
      }
    }
  }

  ${fromScreen(776)} {
    .header-course {
      grid-template-columns: 1fr 332px;
      grid-row-gap: 0px;
      grid-column-gap: 20px;
    }
    .header-content {
      .last-updated-at {
        margin-top: 14px;
      }
    }

    ${LevelVideo} {
      .thumbnail {
        max-height: 186px;
      }
    }
  }

  ${fromScreen(1144)} {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 28px;
  }
`;

const TextContainer = styled.div`
  .header-title {
    display: grid;
    gap: 4px;
  }
  ${fromScreen(776)} {
    .header-title {
      .rating {
        display: flex;
        > div {
          margin-left: 8px;
        }
      }
    }
    ${VideoContainer} {
      .btn-action {
        display: none;
      }
    }
  }
`;

Header.propTypes = {
  level: PropTypes.shape({
    levelDisplay: PropTypes.string,
    levelDescription: PropTypes.string
  })
};
